import PercentageHeaderFormatter from '../../view/common/table/formatters/PercentageHeaderFormatter';
import PercentageShortTextCell from '../../view/common/table/formatters/PercentageShortTextCell';
import {
    FORMATTER_DATA_TYPES,
    CUSTOM_SORT_PERCENTAGE_COLUMN
} from '../../view/common/table/formatters/constants';
import { BaseTableTransformer } from './BootstrapTableTransformer';

export class LiftProgressTableTransformer extends BaseTableTransformer {
    transformColumns(columns) {
        const baseColumns = super.transformColumns(columns);
        return baseColumns.map(column => {
            if (column.units === FORMATTER_DATA_TYPES.PERCENT) {
                column.dataType = FORMATTER_DATA_TYPES.STRING;
                column.headerFormatter = PercentageHeaderFormatter;
                column.formatter = PercentageShortTextCell;
                column.sortFunc = CUSTOM_SORT_PERCENTAGE_COLUMN;
            }
            return column;
        });
    }

    transformRows(rows) {
        const baseRows = super.transformRows(rows);
        return baseRows.map(row => {
            row.difference_percentage = row.difference_percentage + '%';
            return row;
        });
    }
}
